import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { Box } from '@chakra-ui/react';
import PrivateRoute from './PrivateRoute';
import CourseDetails from './Courses/CourseDetails';
import Courses from './Courses/Courses';
import Questions from './Quizzes/Questions';
import QuizDetails from './Quizzes/QuizDetails';
import Quizzes from './Quizzes/Quizzes';
import Login from './login/login';
import ForgotPass from './login/forgotpass';
import ProfilePage from './profile/profile';
import NewPassword from './login/resetpassword';
import NotFound from './common/notfound';
import Layout from './common/layout';
import Home from './Home/Home';
import AnnouncementsWrapper from '../Announcements/AnnouncementsWrapper';
import MyActivity from '../MyActivity/MyActivity';
import LiveSessions from './LiveSessions/LiveSessions';
import Register from './Register/Register';

function withLayout(WrappedComponent) {
  return (props) => {
    return (
      <Layout>
        <WrappedComponent {...props}></WrappedComponent>
      </Layout>
    );
  };
}

function withoutLayout(WrappedComponent) {
  return (props) => {
    return (
      <Box minH='100vh'>
        <Box
          pt='10vh'
          d='flex'
          justifyContent='center'
          alignItems='center'
          bg='#fcfcfc'
          width='100%'
        >
          <WrappedComponent {...props}></WrappedComponent>
        </Box>
      </Box>
    );
  }
}

export default function App() {
  console.log('in router');
  return (
    <Router>
      <Switch>
        <PrivateRoute exact path='/' component={withLayout(Home)} />
        <PrivateRoute exact path='/home' component={withLayout(Home)} />
        <Route exact path='/login' component={withoutLayout(Login)} />
        <Route exact path='/register' component={withoutLayout(Register)} />
        <Route exact path='/forgot' component={withoutLayout(ForgotPass)} />
        <Route exact path='/passwordchange' component={withoutLayout(NewPassword)} />
        <PrivateRoute exact path='/courses' component={withLayout(Courses)} />
        <PrivateRoute path='/courses/:id' component={withLayout(CourseDetails)} />
        <PrivateRoute exact path='/quizzes' component={withLayout(Quizzes)} />
        <PrivateRoute path='/quizzes/:id' component={withLayout(QuizDetails)} />
        <PrivateRoute exact path='/test-attempt' component={withLayout(Questions)} />
        <PrivateRoute exact path='/profile' component={withLayout(ProfilePage)} />
        <PrivateRoute exact path='/announcements' component={withLayout(AnnouncementsWrapper)} />
        <PrivateRoute exact path='/my-activity' component={withLayout(MyActivity)} />
        <PrivateRoute exact path='/live-sessions' component={withLayout(LiveSessions)} />
        <Route component={withLayout(NotFound)} />
      </Switch>
    </Router>
  );
}
